module.exports = __webpack_public_path__ + "img/icone-servico-certidao.5bf38c76.png";